import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import SignIn from "layouts/authentication/sign-in";
import FormBuilder from "layouts/forms/components/form-builder";
import WebsiteList from "layouts/LandPage";
import Users from "layouts/users";

// Website-detail nested route tree
import WebsiteLayout from "layouts/website/WebsiteLayout";
import WebsiteDashboard from "layouts/website/WebsiteDashboard";
import FormsRoute from "layouts/website/FormsRoute";
import EmailTemplatesRoute from "layouts/website/EmailTemplatesRoute";
import AuthorsListPage from "layouts/website/AuthorsListPage";
import CategoriesListPage from "layouts/website/CategoriesListPage";
import TagsListPage from "layouts/website/TagsListPage";
import MediaLibraryPage from "layouts/website/MediaLibraryPage";
import BuildConfigPage from "layouts/website/BuildConfigPage";
import ContentListPage from "layouts/website/content/ContentListPage";
import { CONTENT_TYPE_KEYS, getContentType } from "config/contentTypeRegistry";

// @mui icons
import Icon from "@mui/material/Icon";

// One child route per content type, e.g. /websites/:websitename/articles
const contentTypeChildren = CONTENT_TYPE_KEYS.map((typeKey) => ({
  key: getContentType(typeKey).typeKey,
  path: typeKey,
  component: <ContentListPage typeKey={typeKey} />,
}));

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Websites",
    key: "websites-list",
    icon: <Icon fontSize="small">language</Icon>,
    route: "/websites",
    component: <WebsiteList />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/users",
    component: <Users />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Website Details",
    key: "website-details",
    icon: <Icon fontSize="small">language</Icon>,
    route: "/websites/:websitename",
    component: <WebsiteLayout />,
    protected: true,
    children: [
      { key: "website-dashboard", index: true, component: <WebsiteDashboard /> },
      ...contentTypeChildren,
      { key: "website-categories", path: "categories", component: <CategoriesListPage /> },
      { key: "website-tags", path: "tags", component: <TagsListPage /> },
      { key: "website-authors", path: "authors", component: <AuthorsListPage /> },
      { key: "website-forms", path: "forms", component: <FormsRoute /> },
      { key: "website-submissions", path: "forms/:formId/submissions", component: <Tables /> },
      {
        key: "website-email-templates",
        path: "email-templates",
        component: <EmailTemplatesRoute />,
      },
      { key: "website-media", path: "media", component: <MediaLibraryPage /> },
      { key: "website-settings", path: "settings", component: <BuildConfigPage /> },
    ],
  },
  {
    type: "collapse",
    name: "Form Builder",
    key: "form-builder",
    icon: <Icon fontSize="small">build</Icon>,
    route: "/websites/:websitename/form-builder/:formSlug?",
    component: <FormBuilder />,
    protected: true,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication",
    component: <SignIn />,
    protected: false,
  },
];

export default routes;
